// @ai-generated 2026-07-03T20:30:00Z by dimitri.driediger@synqony.com using Claude Fable 5

/** Error keys of the positions step: one general key plus per-position keys for material and quantity. */
export type PositionsStepErrorKey = 'positions' | `material-${string}` | `quantity-${string}`;

/** Wizard error key of the material dropdown of one position. */
export const materialErrorKey = (positionId: string): PositionsStepErrorKey => `material-${positionId}`;

/** Wizard error key of the quantity field of one position. */
export const quantityErrorKey = (positionId: string): PositionsStepErrorKey => `quantity-${positionId}`;
